export const WIDGET_TOKEN_REQUEST_PENDING = 'widget_token_request_pending';
export const WIDGET_TOKEN_REQUEST_RECEIVED = 'widget_token_request_received';
export const WIDGET_TOKEN_REQUEST_ERROR = 'widget_token_request_error';
export const WIDGET_TOKEN_REQUEST_RESET = 'widget_token_request_reset';
